import React, { Component, Fragment } from 'react'
import { Button, Form, Modal, Input, message, Icon, Upload, Select } from 'antd'

import { reviseMerchantl, rejectMerchant, getMerchantCategory } from '_src/api/api'

import { UploadIMGToOss } from '_src/utils/base'

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

const { Option } = Select
@Form.create({ name: 'AddMerchantForm' })
class AddMerchant extends Component {
  constructor (props) {
    super(props)
    this.loading = true
    this.id = ''
    this.upLoadFlage = true // 判断图片是否需要更新上传
    this.param = {
      status: '',
      pageNum: 0,
      
    }
    this.status = ''
    this.pageNum = 0
    this.totalElements = 0
    this.state = {
      typeList: [], // 商户类型选项
      confirmDirty: false, // 确认密码
      visible: false,
      dataList: [],
      previewVisible: false,
      previewImage: '',
      // 图片集合
      fileList: {
        cover: [],
        businessLicense: [],
        idCardObverse: [],
        idCardReverse: []
      },
      erroMsg: ''
    }
  }

  componentDidMount () {
    this.loadType()
  }

  loadType () {
    getMerchantCategory()
      .then(res=>{
        const { data: { content } } = res
        const typeList = content.map((item)=>{
          return { value: item.id, text: item.name }
        })
        const { merchant } = this.props
        merchant && this.setValue()
        this.setState({
          typeList
        })
      })
  }

  // 设值
  setValue = () => {
    const { merchant } = this.props    
    const { merchantName, mobile, storeName, username, category, password, cover, id } = merchant
    this.id = id
    const coverList = cover ? [{ uid: '-1', name: 'merchantAdd', status: 'done', url: cover}] : []
    
    const categoryId = category.id
    const confirm = password
    console.log(password)
    let param = { merchantName, mobile, storeName, username, categoryId, password, confirm }
    this.upLoadFlage = false
    this.setState((preState)=>({
      fileList: {...preState.fileList, cover: [...coverList]}
    }))
    this.props.form.setFieldsValue({
      ...param
    })
    this.props.form.setFieldsValue({
      confirm: password
    })
  }
  // 密码联动
  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true })
    }
    callback()
  };

  // 确认密码
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props
    if (value && value !== form.getFieldValue('password')) {
      callback('两次密码不一致!')
    } else {
      callback()
    }
  };

  handleConfirmBlur = e => {
    const { value } = e.target
    this.setState({ confirmDirty: this.state.confirmDirty || !!value })
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    })
  };

  handleChange = (files, key) => {
    this.upLoadFlage = true
    this.setState({
      erroMsg: ''
    })
    
    // this.upLoadFlage = true
    this.setState((preState)=>(
      { fileList: {...preState.fileList, [key]: files } 
      }))
  }
  
  onSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      // return
      if (!err) {
        const { fileList } = this.state
        const { cover } = fileList
        if (cover.length === 0) {
          this.setState({
            erroMsg: '请上传商家图片'
          })
          return
        }
        else {
          this.hide = message.loading(this.id?'商户修改中':'商户添加中', 0)
          // 需要更新图片
          let {confirm, ...param} = values
          
          param = {...param}
          if (this.upLoadFlage) {
            UploadIMGToOss(cover[0])
              .then((data) => {
                if (data) {
                  param = {...param, cover: data}
                  
                  this.saveSpecial(param)
                } else {
                  this.hide()
                  message.error('图片上传失败！', 1.5)
                }
              })
              .catch(function (err) {
                this.hide()
                message.error('图片上传失败！', 1.5)
                return false
              })
          }
          else {
            // 不需要更新图片
            const { url } = this.state.fileList.cover[0]
            this.saveSpecial({...param, cover: url})  
          }
          this.setState({
            erroMsg: ''
          })
        }
      }
    })
  }

  // 保存商户
  saveSpecial (param) {
    if (!this.id) {
      // 添加商户
      rejectMerchant(param)
        .then((res)=>{
          this.hide && this.hide()
          const { data: {id} } = res
          message.success('添加成功', 1.5)
          this.props.history.push(`/system/merchant/detail?id=${id}`)
        })
        .catch(()=>{
          // console.log(err)
          this.hide()
        
          message.error('添加失败', 1.5)
        })
    }
    else {
      // 修改商户
      reviseMerchantl(this.id, param)
        .then(()=>{
          this.hide && this.hide()
          message.success('修改成功', 1.5, ()=>{
            const { handleLoad } = this.props
            handleLoad && handleLoad()
          })
        })
        .catch(()=>{
          this.hide()
          message.success('修改失败', 1.5, ()=>{})
        })
    }
  }

  
  render () {
    const { previewVisible, previewImage, fileList, typeList, erroMsg } = this.state
    const { getFieldDecorator } = this.props.form
    const uploadButton = (title) => (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">{title}</div>
      </div>
    )
    return (
      <div className = "AddMerchant page_content">
        
        <div className = "top" style = {{marginBottom: 60}} />
        
        <Form 
          onSubmit={this.onSubmit} 
          className="advert-form" labelCol = {{span: 4}} wrapperCol = {{span: 18}}
          style = {{maxWidth: 600, margin: (0, 'auto') }}
        >
          {/* <Form.Item label="是否显示">
            {getFieldDecorator('status', { valuePropName: 'checked' })(
              <Switch />
            )}
          </Form.Item> */}

          <Form.Item label="商户名称" number>
            {getFieldDecorator('storeName', { rules: [{ required: true, message: '商户名称不能为空', }] })(
              <Input placeholder="请输入商户名称" />)}
          </Form.Item>
          <Form.Item label="店主名称" number>
            {getFieldDecorator('merchantName', { rules: [{ required: true, message: '店主名称不能为空', }] })(
              <Input placeholder="请输入店主名称" />)}
          </Form.Item>
          <Form.Item label="手机号" number>
            {getFieldDecorator('mobile', { rules: [{ required: true, message: '手机号不能为空', }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', }] })(
              <Input placeholder="请输入手机号" />)}
          </Form.Item>
          {/* <Form.Item label="商铺类型" number>
            {getFieldDecorator('categoryId', { rules: [{ required: true, message: '专题名称不能为空', }] })(
              <Input placeholder="请输入选择商户类型" />)}
          </Form.Item> */}
          <Form.Item label="商户类型" hasFeedback>
            {getFieldDecorator('categoryId', {
              rules: [{ required: true, message: '商户类型不能为空' }],
            })(
              <Select placeholder="请输入选择商户类型">
                {typeList.map(item=>{
                  return (
                    <Option value={item.value} key = {item.value}>{item.text}</Option>
                  ) })}
              </Select>,
            )}
          </Form.Item>
          <Form.Item label="账号" number>
            {getFieldDecorator('username', { rules: [{ required: true, message: '账号不能为空'},
              { pattern: /^[A-Za-z0-9]+$/, message: '账号名称不能包含中文或者特性字符串', }
            ] })(
              <Input placeholder="请输入注册的账号" disabled = {!!this.id} />)}
          </Form.Item>
          {/* <Form.Item label="密码" number>
            {getFieldDecorator('password', { rules: [{ required: true, message: '密码不能为空', }] })(
              <Input placeholder="请输入密码" />)}
          </Form.Item> */}

          {!this.id
            ?<Fragment>
              <Form.Item label="密码" hasFeedback>
                {getFieldDecorator('password', {
                  rules: [
                    {
                      required: true,
                      message: '密码不能为空',
                    },
                    {
                      min: 6,
                      message: '密码不能少于6个字符',
                    }, {
                      max: 20,
                      message: '密码不能大于20个字符',
                    },
                    {
                      validator: this.validateToNextPassword,
                    },
                  ],
                })(<Input.Password placeholder="请输入密码" />)}
              </Form.Item>
              <Form.Item label="确认密码" hasFeedback>
                {getFieldDecorator('confirm', {
                  rules: [
                    {
                      required: true,
                      message: '请重新确认密码',
                    },
                    {
                      validator: this.compareToFirstPassword,
                    },
                  ],
                })(<Input.Password placeholder="请再次确认密码" onBlur={this.handleConfirmBlur} />)}
              </Form.Item>
            </Fragment>
            :<Fragment>
              <Form.Item label="密码" hasFeedback>
                {getFieldDecorator('password', {
                  rules: [
                    {
                      min: 6,
                      message: '密码不能少于6个字符',
                    }, {
                      max: 20,
                      message: '密码不能大于20个字符',
                    },
                    {
                      validator: this.validateToNextPassword,
                    },
                  ],
                })(<Input.Password placeholder="请输入密码" />)}
              </Form.Item>
              <Form.Item label="确认密码" hasFeedback>
                {getFieldDecorator('confirm', {
                  rules: [

                    {
                      validator: this.compareToFirstPassword,
                    },
                  ],
                })(<Input.Password placeholder="请再次确认密码" onBlur={this.handleConfirmBlur} />)}
              </Form.Item>
            </Fragment>
          }

          <Form.Item label='图片上传' validateStatus = "error" help={erroMsg}>
            <div style = {{ display: 'flex'}}>
              <Upload
                action=""
                listType="picture-card"
                fileList={fileList.cover}
                onPreview={this.handlePreview}
                onChange={({fileList}) => this.handleChange(fileList, 'cover')}
                beforeUpload = {()=>{ return false }}
              >
                {fileList.cover.length >= 1 ? null : uploadButton(<FormLabel text = "商家图片" />)}
              </Upload>
              {/* <Upload
                action=""
                listType="picture-card"
                fileList={fileList.businessLicense}
                onPreview={this.handlePreview}
                onChange={({fileList}) => this.handleChange(fileList, ' ')}
                beforeUpload = {()=>{ return false }}
              >
                {fileList.businessLicense.length >= 1 ? null : uploadButton('营业执照')}
              </Upload>
              <Upload
                action=""
                listType="picture-card"
                fileList={fileList.idCardObverse}
                onPreview={this.handlePreview}
                onChange={({fileList}) => this.handleChange(fileList, 'idCardObverse')}
                beforeUpload = {()=>{ return false }}
              >
                {fileList.idCardObverse.length >= 1 ? null : uploadButton('身份证正面')}
              </Upload>
              <Upload
                action=""
                listType="picture-card"
                fileList={fileList.idCardReverse}
                onPreview={this.handlePreview}
                onChange={({fileList}) => this.handleChange(fileList, 'idCardReverse')}
                beforeUpload = {()=>{ return false }}
              >
                {fileList.idCardReverse.length >= 1 ? null : uploadButton('身份证反面')}
              </Upload> */}

            
              <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                <img alt="example" style={{ width: '100%' }} src={previewImage} />
              </Modal>
            </div>
          </Form.Item>
          
          <Form.Item style={{ paddingLeft: 140, textAlign: 'center' }}>
            <Button type="primary" htmlType="submit" icon='save' style={{ width: 248}}>保存</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const FormLabel = (props) => {
  const { text } = props
  return (
    <span><i style = {{color: 'red', marginRight: 6}}>*</i>{text}</span>
  )
}

export default AddMerchant